import { Directive, Input, HostListener, ElementRef, Optional, AfterViewInit } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[sanitizeInput]'
})
export class SanitizeInputDirective implements AfterViewInit {

  @Input('sanitizeInput') field: any;

  private maliciousPattern = /(<script.*?>.*?<\/script>|<.*?>|javascript:|onerror=|onload=)/gi;

  constructor(@Optional() private control: NgControl, private el: ElementRef) {}

  ngAfterViewInit() {
    // If reactive form exists, sanitize programmatic changes
    if (this.control && this.control.control) {
      this.control.control.valueChanges.subscribe((value: string) => {
        if (!value) return;
        this.sanitize(value);
      });
    }

    // Initial sanitization for [value] binding
    if (this.field && this.field.data) {
      this.sanitize(this.field.data);
    }
  }

  @HostListener('input', ['$event'])
  onInput(event: any) {
    this.sanitize(event.target.value);
  }

  private sanitize(value: string) {
    const sanitized = value.replace(this.maliciousPattern, '');

    // Update the DOM
    if (this.el && this.el.nativeElement) {
      this.el.nativeElement.value = sanitized;
    }

    // Update your dynamic field object
    if (this.field) {
      this.field.data = sanitized;
      this.field.newData = sanitized; // keep in sync with your formGenerator
    }

    // Update FormControl if exists
    if (this.control && this.control.control) {
      this.control.control.setValue(sanitized, { emitEvent: false });
    }
  }
}
